/** A one-line success the shell shows as a toast once the workspace opens (after a page load), then forgets. */
export const NOTICE_KEY = "av-notice";

export function leaveNotice(title: string) {
  sessionStorage.setItem(NOTICE_KEY, title);
}

export function takeNotice(): string | null {
  const title = sessionStorage.getItem(NOTICE_KEY);
  if (title) sessionStorage.removeItem(NOTICE_KEY);
  return title;
}
